import { render, staticRenderFns } from "./badge_bonus_release.vue?vue&type=template&id=57b04898&"
import script from "./badge_bonus_release.vue?vue&type=script&lang=js&"
export * from "./badge_bonus_release.vue?vue&type=script&lang=js&"
import style0 from "./badge_bonus_release.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports